import React from "react";
import Layout from "../Layout";
import HeaderOrg from "./HeaderOrg";
import ListOrg from "./ListOrg/ListOrg";
import AddOrgEmail from "../shared/AddOrgEmail";
import SearchOrg from "./SearchOrg";
import XdrSetting from "./XdrSetting";
import OrgCsrModal from "./OrgCSRModal";

const Organizations = () => {

  return (
    <Layout>
      <HeaderOrg />
      <ListOrg />
      <AddOrgEmail />
      <SearchOrg />
      <XdrSetting />
      <AddOrgEmail />
      <OrgCsrModal />
    </Layout>
  );
};


export default Organizations;
